<template>
    <div class="fixed-modal-doc-viewer" :class="{'fixed-modal-doc-viewer-office': /\.(docx|xlsx|pptx|doc|xls|ppt)$/i.test(file_name_for_view)}" >
        <div v-if="/\.(docx|xlsx|pptx|doc|xls|ppt)$/i.test(file_name_for_view)" class="position-absolute close-icon-for-viewer" :class="{'close-icon-for-viewer-office': /\.(docx|xlsx|pptx|doc|xls|ppt)$/i.test(file_name_for_view)}">
          <h1 class="fs-16 text-secondary pt-5 pl-5">{{file_name_for_view}}</h1>
          <span class="position-absolute pointer" style="right: 15px; top: 15px;">
            <i class="icon icon-close fs-18 text-black" @click="hideFileViewer" style="left: 3px;" ></i>
          </span>
        </div>
        <div class="position-absolute close-icon-for-viewer-other" v-else>
          <h1 class="fs-16 text-secondary pt-3 pl-5">{{file_name_for_view}}</h1>
          <span class="position-absolute pointer" style="right: 15px; top: 10px;">
            <i class="icon icon-close fs-18 text-black" @click="hideFileViewer" style="left: 3px;" ></i>
          </span>
        </div>
        <template v-if="fileUrl == '' || fileUrl == null || fileUrl == undefined">
          <div class="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
            <h1 class="fs-16 py-5 text-center"> File Type Not Supported</h1>
          </div>
        </template>
        <template v-else>
          <!-- <iframe id="wacParentframenew" ref="officeViewer" :src="'https://view.officeapps.live.com/op/view.aspx?src=https://cdn.digicollect.com/cdn/hrms_fe_v2/test.doc#toolbar=0'" frameborder="0" width="100%" height="100%" ></iframe> -->
          <iframe v-if="/\.(docx|xlsx|pptx|doc|xls|ppt)$/i.test(file_name_for_view)" id="wacParentframe" ref="myIframe" :src="'https://view.officeapps.live.com/op/embed.aspx?src='+fileUrl" frameborder="0" width="100%" height="100%" ></iframe>
          <!-- <div v-else-if="file_type_for_view == 'application/pdf'" class="w-100 h-100"> -->
          <div v-else-if="/\.(pdf|svg|txt)$/i.test(file_name_for_view)" class="w-100 h-100">
              <iframe :src="'https://docs.google.com/viewer?url='+fileUrl+'&embedded=true'" frameborder="0" width="100%" height="100%" ></iframe>
              <!-- <div class="w-100 h-100" id="PdfViewerNew">
  
              </div> -->
          </div>
          <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
            <h1 class="fs-16 py-5 text-center"> File Type Not Supported</h1>
          </div>
        </template>
        <!-- <div v-if="/\.(docx|xlsx|pptx|doc|xls|ppt)$/i.test(file_name_for_view)" style="position: absolute;right: 40px;bottom: 0;width: 40px;height: 22px;background:#fff"></div> -->
        <!-- v-else  -->
        <!-- 
            hide-light - docx
            hide-dark - xlsx,pptx
            display-none - pdf, txt, svg
        -->
        <!-- <div :class="{'hide-dark' : /\.(docx|xlsx|pptx|doc|xls|ppt)$/i.test(file_name_for_view), 'hide-light': /\.(pdf|svg|txt)$/i.test(file_name_for_view)}"></div> -->
        <div :class="{'hide-light' : /\.(docx|doc)$/i.test(file_name_for_view), 'hide-dark': /\.(xlsx|pptx|xls|ppt)$/i.test(file_name_for_view), 'display-none' : /\.(pdf|svg|txt)$/i.test(file_name_for_view)}"></div>
    </div>
</template>
<script>
import Axios from 'axios';
import {HollowDotsSpinner} from 'epic-spinners';
// import PDFJSExpress from '@pdftron/pdfjs-express-viewer'
export default {
props: ["fileUrl","fileType","file_name_for_view","file_type_for_view"],
data() {
    return {
    pdfUrl: '',
    previewType: '',
    isLoading: true,
    page: 1,
    pageCount: 1,
    showAllPages: false,
    };
},
components: {
    HollowDotsSpinner,
},
watch: {
    showAllPages() {
        this.page = this.showAllPages ? null : 1
    },
},
mounted() {
    //   PDFJSExpress(
    //   {
    //     path: '/static/pdfjsexpress',
    //     // path: 'https://storage.googleapis.com/',
    //     // initialDoc: '/static/f866c5a9-1568-4f63-b1d8-6353d10f24de.pdf',
    //     licenseKey: 'xDcYT6Z1D7Rmf4R5N0Zq',
    //   },
    //   document.getElementById('PdfViewerNew')
    // ).then(instance => {
    //   const { UI, Core } = instance;
    //   const { documentViewer, annotationManager, Tools, Annotations } = Core;
    //   // call methods from UI, Core, documentViewer and annotationManager as needed

    //   documentViewer.addEventListener('documentLoaded', () => {
    //     // call methods relating to the loaded document
    //   });

    //   instance.UI.loadDocument(this.fileUrl);
    // })
    // Add event listener for keydown
    document.addEventListener('keydown', this.handleKeyDown);
},
beforeDestroy() {
    // Remove event listener when component is destroyed
    document.removeEventListener('keydown', this.handleKeyDown);
},
computed: {

},
methods: {
    hideFileViewer(){
    this.$emit('hideFileViewer')
    },
    handleIFrameLoad() {
    // const iframe = this.$refs.myIframe;
    const iframe = document.getElementById('wacParentframe');
    iframe.contentWindow.postMessage('requestCSSChange', '*');
    this.injectIframeStyle()
    },
    changeIFrameCSS() {
    // Handle CSS change on receiving message from iframe
    },
    handleDocumentRender() {
        this.isLoading = false
        this.pageCount = this.$refs.pdfRef.pageCount
    },
    handlePasswordRequest(callback, retry) {
        callback(prompt(retry
            ? 'Enter password again'
            : 'Enter password'
        ))
    },
    injectIframeStyle() {
    const iframe = document.getElementById('wacParentframe');
    const cssString = `
        body {
        background-color: lightblue;
        }
    `;
    let iframeContent = iframe.contentWindow
    // iframe.contentWindow.frames.contentWindow.postMessage({ css: cssString }, '*'); // Replace '*' with the target iframe's origin if known
    // iframe.contentWindow.frames.postMessage({ css: cssString }, '*')
    if (iframeContent) {
        const body = iframeContent.body;
        if (body) {
        body.style.backgroundColor = 'lightblue';
        }
    }
    },
    handleKeyDown(event) {
    // Check if the pressed key is the print screen key
    if (event.key === 'PrintScreen' || event.key === 'PrtScn' || event.keyCode === 44) {
        // Prevent the default behavior (taking a screenshot)
        event.preventDefault();
        // Optionally, you can also stop the event from propagating further
        event.stopPropagation();
        // Optionally, you can show a message or perform some other action
    }
    }
}
};
</script>

<style scoped>
.fixed-modal-doc-viewer {
position: fixed;
top: 0;
right: 0;
left: 0;
bottom: 0;
width: 100%;
height: 100%;
z-index: 99999999;
}
.testing-viewer {
height: 100% !important;
}
.testing-viewer #AppHeaderPanel {
display: none !important;
}
.cui-exth .WACRibbonPanel {
display: none !important;
}

.cui-ribbonTopBars, .cui-tabBody, .cui-cg-i, .cui-ct-ul, .cui-tabContainer {
display: none !important;
}
.ndfHFb-c4YZDc-Wrql6b {
display: none !important;
}
button[aria-label="Accessibility Mode"] {
display: none !important;
}
.close-icon-for-viewer {
    right: 0;
    top: 0;
    z-index: 99999;
    background-color: #fff;
    width: 100%;
    height: 60px;
}
.close-icon-for-viewer-other {
    right: 0;
    top: 0;
    z-index: 99999;
    background-color: #fff;
    width: 100%;
    height: 50px;
}
.controls {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
}
button {
    margin: 0 0.5rem;
}
.fixed-modal-doc-viewer-office {
    top: 60px;
    height: auto;
}
.close-icon-for-viewer-office {
    top: -60px;
    height: 60px;
}
.hide-dark,
.hide-light{
    position: absolute;
    right: 40px;
    bottom: 0;
    width: 40px;
    height: 22px;
    background:url(https://res-1.cdn.office.net:443/officeonline/x/s/hDEF6F7343B3FA794__layouts/Resources/ewaembed.png)
}
.hide-dark{
    right: 29px;
    bottom: 0;
    width: 51px;
    height: 25px;
    background:url(https://res-1.cdn.office.net:443/officeonline/x/s/hDEF6F7343B3FA794__layouts/Resources/ewaembed.png)
}
.hide-light{
    background:#fff
}
.display-none{
    display: none
}
</style>
  